import type { CarrierTrackingView } from '@wms/domain';
import { carrierLabel, fmt } from './format';
import type { OrderSummary } from './types';

// Kargo takibi in the order screens: the number the parcel is followed by, linked to the carrier's
// public page of that one number (never an account-wide link), and what the carrier last said.

export type Tracked = Pick<OrderSummary, 'trackingNumber' | 'trackingUrl' | 'carrierTracking'>;

/** The order's own number, else the one the carrier gave; with its public page when known. */
export function trackingOf(o: Tracked): { readonly number: string | null; readonly url: string | null } {
  const ct = o.carrierTracking ?? null;
  if (o.trackingNumber) return { number: o.trackingNumber, url: o.trackingUrl ?? (ct?.trackingNumber === o.trackingNumber ? ct.trackingUrl : null) };
  return { number: ct?.trackingNumber ?? null, url: ct?.trackingUrl ?? null };
}

/** "az önce", "12 dk önce", "3 sa önce" */
export const ago = (iso: string) => (fmt.age(iso) === '0 dk' ? 'az önce' : `${fmt.age(iso)} önce`);

/** "Aras", else the carrier's full name. */
export const carrierShort = (code: string) => (code === 'aras' ? 'Aras' : carrierLabel(code));

/** "Aras: Yolda · 20/10 14:35"; null until the carrier reported the parcel's state. */
export function carrierStateLine(ct: CarrierTrackingView | null | undefined): string | null {
  if (!ct?.stateText) return null;
  // the return's words already name the carrier ("Aras: iade ediliyor")
  const words = ct.returning ? ct.stateText : `${carrierShort(ct.carrierCode)}: ${ct.stateText}`;
  const at = ct.deliveredAt ?? ct.eventAt;
  return at ? `${words} · ${fmt.dateTime(at)}` : words;
}
